"use client";

import { Icons } from "@masterkey/ui/icons";
import { LogOut } from "lucide-react";

import { useUser } from "@/hooks/useUser";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { UserAvatar } from "@/components/ui/user-avatar";

export const UserProfileDropdown = () => {
  const { avatarUrl, handleSignOut } = useUser();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <UserAvatar avatarUrl={avatarUrl} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleSignOut}>
          <Icons.SignOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const SidebarLogout = () => {
  const { handleSignOut } = useUser();

  return (
    <button
      onClick={handleSignOut}
      className="flex items-center text-sm font-semibold rounded-md px-3 py-2 hover:bg-chalk"
      type="button"
    >
      <LogOut size={16} className="mr-2" />
      Logout
    </button>
  );
};
